
import {Fragment, useState, useEffect } from 'react';
import {capitalize, handlerBy} from '../Utils';
import SimpleSelect from '../SimpleSelect';
import { Box, Checkbox, FormControlLabel, Grid, Tab, Typography } from '@mui/material';
import { TabContext, TabList } from '@mui/lab';
import { hourOptions} from '../Utils'

const daysOfWeek = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
const daysOfWeekFR = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
const capDaysOfWeek = daysOfWeek.map(day => capitalize(day));

// const recurrentScheduleTabs = daysOfWeekFR.map(day => ({
//   id: day,
//   content: capitalize(day),
//   panelId: day + "-content-1"
// }));

export default function RecurrentSchedule ({recurrentSchedule, setRecurrentSchedule}) {

  const [selected, setSelected] = useState(0);
  const [isWorkingDay, setIsWorkingDay] = useState(false);
  const [hasTwoIntervals, setHasTwoIntervals] = useState(false);

  useEffect(() => {
    updateStateOfChecks(selected);
  }, [recurrentSchedule]);

  // <Select
  //       value={String(this.props.hour)}
  //       onChange={this.props.changeHour}
  //       label={this.props.title}
  //       options={hourOptions}
  //     />
  
  const updateStateOfChecks = (selected) => {    
    const isWorkingDay = recurrentSchedule[capDaysOfWeek[selected]].morningStart !== -1;
    const hasTwoIntervals = recurrentSchedule[capDaysOfWeek[selected]].afternoonStart !== -1;
    setSelected(selected);
    setIsWorkingDay(isWorkingDay);
    setHasTwoIntervals(hasTwoIntervals);
  }

  // componentDidMount() {
  //   this.updateStateOfChecks(0);
  // }

  const resetIntervalHours = (day, intervals) => {
    let newRecurrentSchedule = {...recurrentSchedule}
    newRecurrentSchedule[day] = {...newRecurrentSchedule[day]}
    for (let interval of intervals) {
      newRecurrentSchedule[day][interval + "Start"] = -1;
      newRecurrentSchedule[day][interval + "End"] = -1;
    }
    setRecurrentSchedule(newRecurrentSchedule);
  }

  const handleIsWorkingDayChange = (event, value) => {
    if(!value) {
      resetIntervalHours(capDaysOfWeek[selected], ["morning", "afternoon"]);
    }
    let newIsWorkingDay = value;
    let newHasTwoIntervals = hasTwoIntervals;
    if(!value) {
      newHasTwoIntervals = false;
    }
    setIsWorkingDay(newIsWorkingDay);
    setHasTwoIntervals(newHasTwoIntervals);
  }

  const handleHasTwoIntervalsChange = (event, value) => {
    if(!value) {
      resetIntervalHours(capDaysOfWeek[selected], ["afternoon"]);
    }
    let newHasTwoIntervals = value;
    setHasTwoIntervals(newHasTwoIntervals);
  }

  const changeHour = (day, bound) => {
    return (value) => {
      let newRecurrentSchedule = {...recurrentSchedule}
      newRecurrentSchedule[day] = {...newRecurrentSchedule[day]}
      newRecurrentSchedule[day][bound] = parseFloat(value);
      setRecurrentSchedule(newRecurrentSchedule);
    }
  }

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  const handleTabChange = (event, selectedTabIndex) => {
    // this.setState({ selected: selectedTabIndex });
    updateStateOfChecks(parseInt(selectedTabIndex));
  }

  let firstInterval = (<Fragment/>);
  if(isWorkingDay) {
    firstInterval = (
      <>
        <Grid item sm={6} xs={12} >
          <SimpleSelect
            value={String(recurrentSchedule[capDaysOfWeek[selected]].morningStart)}
            onChange={handlerBy(changeHour(capDaysOfWeek[selected], "morningStart"))}
            label="Début"
            options={hourOptions}
          />
        </Grid>
        <Grid item sm={6} xs={12} >
          <SimpleSelect
            value={String(recurrentSchedule[capDaysOfWeek[selected]].morningEnd)}
            onChange={handlerBy(changeHour(capDaysOfWeek[selected], "morningEnd"))}
            label="Fin"
            options={hourOptions}
          />
        </Grid>
      </>
      // <FormLayout.Group condensed>
      //   <HourSelect title="Début" hour={recurrentSchedule[capDaysOfWeek[selected]].morningStart}
      //       changeHour={this.changeHour(capDaysOfWeek[selected], "morningStart")}
      //   />
      //   <HourSelect title="Fin" hour={recurrentSchedule[capDaysOfWeek[selected]].morningEnd}
      //       changeHour={this.changeHour(capDaysOfWeek[selected], "morningEnd")}
      //   />
      // </FormLayout.Group>
    )
  }

  let secondInterval = (<Fragment/>);
  if(hasTwoIntervals) {
    secondInterval = (
      <>
        <Grid item sm={6} xs={12} >
          <SimpleSelect
            value={String(recurrentSchedule[capDaysOfWeek[selected]].afternoonStart)}
            onChange={handlerBy(changeHour(capDaysOfWeek[selected], "afternoonStart"))}
            label="Début"
            options={hourOptions}
          />
        </Grid>
        <Grid item sm={6} xs={12} >
          <SimpleSelect
            value={String(recurrentSchedule[capDaysOfWeek[selected]].afternoonEnd)}
            onChange={handlerBy(changeHour(capDaysOfWeek[selected], "afternoonEnd"))}
            label="Fin"
            options={hourOptions}
          />
        </Grid>
      </>
      // <FormLayout.Group condensed>
      //   <HourSelect title="Début" hour={recurrentSchedule[capDaysOfWeek[selected]].afternoonStart}
      //       changeHour={this.changeHour(capDaysOfWeek[selected], "afternoonStart")}
      //   />
      //   <HourSelect title="Fin" hour={recurrentSchedule[capDaysOfWeek[selected]].afternoonEnd}
      //       changeHour={this.changeHour(capDaysOfWeek[selected], "afternoonEnd")}
      //   />
      // </FormLayout.Group>
    )
  }

  // console.log(recurrentSchedule);
  
  return (
    <>
      <Grid container spacing={4} wrap="wrap">
        <Grid item sm={12} xs={12} >
          <Typography color="textPrimary" variant="h6">
            Horaires d'ouverture récurrents
          </Typography>
        </Grid>        
        <Grid item sm={12} xs={12} >
          <TabContext value={""+selected} variant="fullWidth">
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange}>
                {daysOfWeekFR.map((day, idx) => <Tab label={day} value={""+idx} key={idx} />)}
              </TabList>
            </Box>
          </TabContext>
        </Grid>
        <Grid item sm={12} xs={12} sx={{ display: 'flex', flexDirection: 'column'}} >
          <FormControlLabel label="Jour travaillé" control={<Checkbox 
            checked={isWorkingDay}
            onChange={handleIsWorkingDayChange}
          />} />
        {/* </Grid>
        <Grid item sm={12} xs={12} > */}
          <FormControlLabel label="Deux plages horaires" disabled={!isWorkingDay} control={<Checkbox 
            checked={hasTwoIntervals}
            onChange={handleHasTwoIntervalsChange}
          />} />
        </Grid>
        {firstInterval}
        {secondInterval}    
      </Grid>
    </>
  )
}
